interface SelfPRProps {
  self_pr: string;
}

export function SelfPR({ self_pr }: SelfPRProps) {
  return (
    <section className="no-page-break">
      <h2 className="jp-heading break-after-avoid text-2xl print:text-xl font-black tracking-[0.04em] text-ink">
        自己PR
      </h2>
      <p className="mt-6 print:mt-3 whitespace-pre-line text-[15.5px] leading-[1.95] print:text-[13.5px] print:leading-[1.75] text-ink">
        {self_pr}
      </p>
    </section>
  );
}
